import "core-js/modules/es.promise.finally.js";
import * as n from "react";
import { useRef as t, useEffect as r, useState as e, useLayoutEffect as o, useMemo as i, useCallback as u } from "react";
import c from "lodash/debounce";
import a from "lodash/isEqual";
import f from "lodash/isUndefined";

function l(n, t) {
  var r = Object.keys(n);

  if (Object.getOwnPropertySymbols) {
    var e = Object.getOwnPropertySymbols(n);
    t && (e = e.filter(function (t) {
      return Object.getOwnPropertyDescriptor(n, t).enumerable;
    })), r.push.apply(r, e);
  }

  return r;
}

function v(n) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? l(Object(r), !0).forEach(function (t) {
      y(n, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(r)) : l(Object(r)).forEach(function (t) {
      Object.defineProperty(n, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }

  return n;
}

function d(n) {
  return d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
    return typeof n;
  } : function (n) {
    return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, d(n);
}

function y(n, t, r) {
  return t in n ? Object.defineProperty(n, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[t] = r, n;
}

function s(n, t) {
  return function (n) {
    if (Array.isArray(n)) return n;
  }(n) || function (n, t) {
    var r = null == n ? null : "undefined" != typeof Symbol && n[Symbol.iterator] || n["@@iterator"];
    if (null == r) return;
    var e,
        o,
        i = [],
        u = !0,
        c = !1;

    try {
      for (r = r.call(n); !(u = (e = r.next()).done) && (i.push(e.value), !t || i.length !== t); u = !0) {
        ;
      }
    } catch (n) {
      c = !0, o = n;
    } finally {
      try {
        u || null == r.return || r.return();
      } finally {
        if (c) throw o;
      }
    }

    return i;
  }(n, t) || m(n, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function p(n) {
  return function (n) {
    if (Array.isArray(n)) return b(n);
  }(n) || function (n) {
    if ("undefined" != typeof Symbol && null != n[Symbol.iterator] || null != n["@@iterator"]) return Array.from(n);
  }(n) || m(n) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function m(n, t) {
  if (n) {
    if ("string" == typeof n) return b(n, t);
    var r = Object.prototype.toString.call(n).slice(8, -1);
    return "Object" === r && n.constructor && (r = n.constructor.name), "Map" === r || "Set" === r ? Array.from(n) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? b(n, t) : void 0;
  }
}

function b(n, t) {
  (null == t || t > n.length) && (t = n.length);

  for (var r = 0, e = new Array(t); r < t; r++) {
    e[r] = n[r];
  }

  return e;
}

function h(n, e) {
  var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
      i = o.options,
      u = o.enabled,
      c = void 0 === u || u,
      a = o.dependencies,
      f = void 0 === a ? [c, n] : a,
      l = o.element,
      y = t(function () {});
  r(function () {
    y.current = e;
  }, [e]), r(function () {
    if (!1 !== c) {
      if ("once" === c || !0 === c) {
        var t = function t(n) {
          y.current(n);
        },
            r = v(v({}, i), {}, {
          once: "once" === c
        });

        return (null != l ? l : document).addEventListener(n, t, r), function () {
          (null != l ? l : document).removeEventListener(n, t, r);
        };
      }

      console.error("Received value of type ".concat(d(c), " for property `enabled`. Expected a boolean."));
    }
  }, f);
}

function g(n, t, o) {
  var i = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
      u = e(),
      c = s(u, 2),
      a = c[0],
      f = c[1];
  return r(function () {
    if (i) {
      var r = new MutationObserver(function () {
        f(o.apply(void 0, arguments));
      });
      return n && r.observe(n, t), function () {
        return r.disconnect();
      };
    }
  }, [n, t, o, i]), a;
}

function w() {
  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
}

function O() {
  var n = s(e(null), 2),
      t = n[0],
      o = n[1];
  return r(function () {
    o(w());
    var n = c(function () {
      return o(w());
    }, 100);
    return window.addEventListener("resize", n), function () {
      return window.removeEventListener("resize", n);
    };
  }, []), t;
}

var j = function j(n, t) {
  return h("keydown", function (t) {
    return function (n, t) {
      27 === n.keyCode && (n.stopImmediatePropagation(), t());
    }(t, n);
  }, t);
};

function S() {
  var n = function n() {
    return "visible" === document.visibilityState;
  },
      t = s(e(!0), 2),
      o = t[0],
      i = t[1];

  return r(function () {
    i(n);
  }, []), h("visibilitychange", function () {
    i(n);
  }), o;
}

function A(n) {
  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      o = e.interval,
      i = void 0 === o ? 3e4 : o,
      u = e.immediate,
      c = void 0 === u || u,
      a = e.enabled,
      f = void 0 === a || a,
      l = t(),
      v = S(),
      d = v && f;
  r(function () {
    l.current = n;
  }), r(function () {
    var n;
    if (d) return c ? e() : t(), r;

    function t() {
      r(), n = setTimeout(e, i);
    }

    function r() {
      clearTimeout(n);
    }

    function e() {
      var n;
      Promise.resolve(null === (n = l.current) || void 0 === n ? void 0 : n.call(l)).finally(t);
    }
  }, [i, c, d]);
}

function E(n) {
  var e = t();
  return r(function () {
    e.current = n;
  }), e.current;
}

function P(n) {
  var r = t();
  return void 0 !== r.current && a(r.current, n) || (r.current = n), r.current;
}

var x = function x() {
  var n = "undefined" == typeof window ? r : o;
  return n.apply(void 0, arguments);
},
    C = !1,
    I = new Map(),
    D = function D(n) {
  if (I.has(n)) {
    var t = I.get(n),
        r = t ? t + 1 : 1;
    return I.set(n, r), r;
  }

  return I.set(n, 1), 1;
};

function M(n) {
  var t = n.prefix,
      o = n.id,
      i = t && (C ? D(t) : null),
      u = s(e(i), 2),
      c = u[0],
      a = u[1];
  return x(function () {
    t && null === c && a(D(t));
  }, []), r(function () {
    !1 === C && (C = !0);
  }, []), o || "".concat(t, "-").concat(c);
}

function k(n) {
  var t = s(e(!1), 2),
      r = t[0],
      o = t[1];
  if (f(n) || "function" != typeof n) return {
    onBlur: function onBlur() {},
    onChange: function onChange() {}
  };
  return {
    onBlur: function onBlur(t) {
      o(!0), null == n || n(t.target.value);
    },
    onChange: function onChange(t) {
      r && (null == n || n(t.target.value));
    }
  };
}

var L = new Map();

function R(t) {
  return function () {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";

    function r(r) {
      if (r) {
        var e = t + "-" + r;
        if (L.get(e)) return L.get(e);
        var o = n.createRef();
        return L.set(e, o), o;
      }

      console.error("useDynamicRefs: Cannot get ref without key");
    }

    return r;
  }(t.prefix);
}

var T = function T(n) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 8,
      r = O();
  return i(function () {
    if (r && n && n.current) {
      var e = n.current.getBoundingClientRect(),
          o = e.top,
          i = e.bottom;
      return Math.max(r.height - i, o) - t;
    }
  }, [r, n, t]);
};

function B(n) {
  var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      e = r.initialValue,
      o = r.deps,
      u = void 0 === o ? [] : o,
      c = t(e);
  return i(function () {
    return {
      get current() {
        return c.current;
      },

      set current(t) {
        c.current = t, n(t);
      }

    };
  }, [n, c].concat(p(u)));
}

function z(n, t) {
  var r = u(function (n, t) {
    Array.isArray(n) ? n.forEach(r) : "function" == typeof n ? n(t) : n && (n.current = t);
  }, []);
  return B(u(function (t) {
    return r(n, t);
  }, [n, r]), {
    initialValue: t
  });
}

export { T as useAvailableSpace, R as useDynamicRefs, j as useEscapeKey, h as useEventListener, z as useForwardedRef, M as useIdAllocator, x as useIsomorphicLayoutEffect, g as useMutationObserver, P as useObjectDependency, B as useObservedRef, A as usePoller, E as usePrevious, k as useValidation, O as useViewportSize };